import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { FixedSizeGrid } from "react-window";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Offcanvas from "react-bootstrap/Offcanvas";
import { saveAs } from "file-saver";
// import { AllSqaures } from "./allSquares"
import "./index.scss";
import {
  buyLandC,
  getAllNfts,
  buyRentOffer,
  approveFtTokens,
  getTokenApproval
} from "../contractInteraction/contractInteraction";
import axios from "axios";
import { collection, doc, getDocs, setDoc } from "firebase/firestore";
import {
  auth,
  firestoredb,
  getmapdata,
  uploadImgPlot,
} from "../../firebase/firebase";
import { Modal } from "react-bootstrap";
import { onAuthStateChanged } from "firebase/auth";
import { useAccount, useWalletClient } from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useNavigate } from "react-router-dom";
import Web3 from "web3";

const TileGrid = () => {
  const { data: signer } = useWalletClient();
  const { address } = useAccount();
  const draggableDivRef = useRef(null);
  const contentRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [MouseGrab, setMouseGrab] = useState(false);
  const [cordinate, setCordinate] = useState("");
  const [modalData, setModalData] = useState({});
  const [panningFlag, setpanningFlag] = useState(false);
  const [nowDownload, setNowDownload] = useState(false);
  const [AllSquares, setAllSquares] = useState([]);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [brandUrl, setBrandUrl] = useState("");
  const [acceptAgreement, setAcceptAgreement] = useState(false);
  const [userTokenApproved, setUserTokenApproved] = useState(false);

  const gridWidth = window.innerWidth;
  const gridHeight = window.innerHeight;
  const numRows = 22; // Change this value to modify the number of rows
  const numCols = 22; // Change this value to modify the number of columns
  const tileHeight = 20; // Adjust the row height as desired
  const tileWidth = 20; // Adjust the column width as desired

  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const mapNumber = "03";
  const navigate = useNavigate()

  const [list, setList] = useState({
    [mapNumber + "-" + "9-8"]: {
      [mapNumber + "-" + "9-8"]: true,
      image: "url(/assets/images/img2.png)",
      imagehtml: "/assets/images/img2.png",
      size: "8-8",
      background: "rgb(148, 143, 101)",
      randomNumber: mapNumber + "260",
      price: 83200,
    },
  });

  function getRandomNumber(min, max, exclusions) {
    let randomNumber;

    do {
      randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    } while (exclusions.includes(randomNumber));

    return randomNumber;
  }

  const NumbertoCordinate = (number) => {
    const row = parseInt(number / 22);
    const col = number % 22;
    const cordinates = row + "-" + col;
    return cordinates;
  };

  var exclusion = [
    184 + 22,
    184 + 23,
    184 + 24,
    184 + 25,
    184 + 26,
    184 + 27,
    184 + 28,
    184 + 29,
    184 + 44,
    184 + 45,
    184 + 46,
    184 + 47,
    184 + 48,
    184 + 49,
    184 + 50,
    184 + 51,
    184 + 66,
    184 + 67,
    184 + 68,
    184 + 69,
    184 + 70,
    184 + 71,
    184 + 72,
    184 + 73,
    184 + 88,
    184 + 89,
    184 + 90,
    184 + 91,
    184 + 92,
    184 + 93,
    184 + 94,
    184 + 95,
    184 + 110,
    184 + 111,
    184 + 112,
    184 + 113,
    184 + 114,
    184 + 115,
    184 + 116,
    184 + 117,
    184 + 132,
    184 + 133,
    184 + 134,
    184 + 135,
    184 + 136,
    184 + 137,
    184 + 138,
    184 + 139,
    184 + 154,
    184 + 155,
    184 + 156,
    184 + 157,
    184 + 158,
    184 + 159,
    184 + 160,
    184 + 161,
    184 + 176,
    184 + 177,
    184 + 178,
    184 + 179,
    184 + 180,
    184 + 181,
    184 + 182,
    184 + 183,
  ];

  const setListArray = () => {
    let count = 0;
    for (let i = 0; i < 10000; i++) {
      const randomNumber = getRandomNumber(1, 418, exclusion);
      if (randomNumber % 22 == 21 || parseInt(randomNumber / 22) >= 18) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 22);
      const test2 = exclusion.includes(randomNumber + 23);
      if (test || test1 || test2) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber);
      }
      const cordinate3 = mapNumber + "-" + NumbertoCordinate(randomNumber);

      const cordinate = cordinate3;
      setList((prev) => ({
        ...prev,
        [cordinate3]: {
          [cordinate3]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "2-2",
          background: "rgb(106, 103, 132)",
          backgroundColor: "rgb(106, 103, 132)",
          randomNumber: mapNumber + randomNumber,
          price: 4200,
        },
      }));
      // console.log("cordinate of random number", cordinate, "and random number", randomNumber);
      if (count == 14) {
        setNowDownload(true);
        console.log(count);
        break;
      }
    }
  };
  const setListArrayEven1 = () => {
    let count = 0;
    for (let i = 0; i <= 80; i += 2) {
      const randomNumber = i;
      if (randomNumber % 22 == 21 || parseInt(randomNumber / 22) == 18) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 22);
      const test2 = exclusion.includes(randomNumber + 23);
      if (test || test1 || test2) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber);
      }
      const cordinate3 = mapNumber + "-" + NumbertoCordinate(randomNumber);
      setList((prev) => ({
        ...prev,
        [cordinate3]: {
          [cordinate3]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "2-2",
          background: "rgb(106, 103, 132)",
          randomNumber: mapNumber + randomNumber,
          price: 4200,
        },
      }));

      // console.log("cordinate of random number", cordinate3);

      if (count == 65) {
        console.log(count);
        break;
      }
    }
  };
  const setListArrayEven2 = () => {
    let count = 0;
    for (let i = 44; i <= 352; i += 22) {
      const randomNumber = i;
      if (randomNumber % 22 == 21 || parseInt(randomNumber / 22) == 18) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 22);
      const test2 = exclusion.includes(randomNumber + 23);
      if (test || test1 || test2) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber);
      }
      const cordinate3 = mapNumber + "-" + NumbertoCordinate(randomNumber);
      setList((prev) => ({
        ...prev,
        [cordinate3]: {
          [cordinate3]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "2-2",
          background: "rgb(106, 103, 132)",
          randomNumber: mapNumber + randomNumber,
          price: 4200,
        },
      }));
    }
  };
  const setListArrayEven3 = () => {
    let count = 0;
    for (let i = 376; i <= 396; i += 2) {
      const randomNumber = i;
      if (randomNumber % 22 == 21 || parseInt(randomNumber / 22) == 18) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 22);
      const test2 = exclusion.includes(randomNumber + 23);
      if (test || test1 || test2) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber);
      }
      const cordinate3 = mapNumber + "-" + NumbertoCordinate(randomNumber);
      setList((prev) => ({
        ...prev,
        [cordinate3]: {
          [cordinate3]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "2-2",
          background: "rgb(106, 103, 132)",
          randomNumber: mapNumber + randomNumber,
          price: 4200,
        },
      }));
    }
  };
  const setListArrayEven4 = () => {
    let count = 0;
    for (let i = 64; i <= 372; i += 22) {
      const randomNumber = i;
      if (randomNumber % 22 == 21 || parseInt(randomNumber / 22) == 18) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 22);
      const test2 = exclusion.includes(randomNumber + 23);
      if (test || test1 || test2) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber);
      }
      const cordinate3 = mapNumber + "-" + NumbertoCordinate(randomNumber);
      setList((prev) => ({
        ...prev,
        [cordinate3]: {
          [cordinate3]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "2-2",
          background: "rgb(106, 103, 132)",
          randomNumber: mapNumber + randomNumber,
          price: 4200,
        },
      }));
    }
  };
  const setListArrayEven5 = () => {
    let count = 0;
    for (let i = 90; i <= 396; i += 22) {
      const randomNumber = i;
      if (randomNumber % 22 == 21 || parseInt(randomNumber / 22) == 18) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 22);
      const test2 = exclusion.includes(randomNumber + 23);
      if (test || test1 || test2) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber);
      }
      const cordinate3 = mapNumber + "-" + NumbertoCordinate(randomNumber);
      setList((prev) => ({
        ...prev,
        [cordinate3]: {
          [cordinate3]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "2-2",
          background: "rgb(106, 103, 132)",
          randomNumber: mapNumber + randomNumber,
          price: 4200,
        },
      }));
    }
  };
  const setListArray4 = () => {
    let count = 0;
    for (let i = 0; i < 465; i++) {
      const randomNumber = getRandomNumber(1, 418, exclusion);

      if (randomNumber % 22 >= 18 || parseInt(randomNumber / 22) > 15) {
        continue;
      }
      const test = exclusion.includes(randomNumber + 1);
      const test1 = exclusion.includes(randomNumber + 2);
      const test2 = exclusion.includes(randomNumber + 3);
      const test3 = exclusion.includes(randomNumber + 22);
      const test4 = exclusion.includes(randomNumber + 23);
      const test5 = exclusion.includes(randomNumber + 24);
      const test6 = exclusion.includes(randomNumber + 25);
      const test7 = exclusion.includes(randomNumber + 44);
      const test8 = exclusion.includes(randomNumber + 45);
      const test9 = exclusion.includes(randomNumber + 46);
      const test10 = exclusion.includes(randomNumber + 47);
      const test11 = exclusion.includes(randomNumber + 66);
      const test12 = exclusion.includes(randomNumber + 67);
      const test13 = exclusion.includes(randomNumber + 68);
      const test14 = exclusion.includes(randomNumber + 69);
      if (
        test ||
        test1 ||
        test2 ||
        test3 ||
        test4 ||
        test5 ||
        test6 ||
        test7 ||
        test8 ||
        test9 ||
        test10 ||
        test11 ||
        test12 ||
        test13 ||
        test14
      ) {
        continue;
      } else {
        count++;
        exclusion.push(randomNumber);
        exclusion.push(randomNumber + 1);
        exclusion.push(randomNumber + 2);
        exclusion.push(randomNumber + 3);
        exclusion.push(randomNumber + 22);
        exclusion.push(randomNumber + 23);
        exclusion.push(randomNumber + 24);
        exclusion.push(randomNumber + 25);
        exclusion.push(randomNumber + 44);
        exclusion.push(randomNumber + 45);
        exclusion.push(randomNumber + 46);
        exclusion.push(randomNumber + 47);
        exclusion.push(randomNumber + 66);
        exclusion.push(randomNumber + 67);
        exclusion.push(randomNumber + 68);
        exclusion.push(randomNumber + 69);
      }
      const cordinate = mapNumber + "-" + NumbertoCordinate(randomNumber);

      setList((prev) => ({
        ...prev,
        [cordinate]: {
          [cordinate]: true,
          image: "url(/assets/images/img2.png)",
          imagehtml: "/assets/images/img2.png",
          size: "4-4",
          background: "rgb(148, 99, 118)",
          randomNumber: mapNumber + randomNumber,
          price: 17600,
        },
      }));
      if (count == 4) {
        break;
      }
    }
  };
  const setListArray1by1 = () => {
    let startRange = 0;
    let endRange = 417;
    const sortedNumbers = exclusion.sort((a, b) => a - b);
    let missing = [];

    for (let i = startRange; i <= endRange; i++) {
      if (!sortedNumbers.includes(i)) {
        missing.push(i);
        const cordinate = mapNumber + "-" + NumbertoCordinate(i);
        setList((prev) => ({
          ...prev,
          [cordinate]: {
            [cordinate]: true,
            image: "url(/assets/images/img2.png)",
            imagehtml: "/assets/images/img2.png",
            size: "1-1",
            background: "#879886",
            randomNumber: mapNumber + i,
            price: 1000,
          },
        }));
      }
    }
  };

  const saveArrayToFile = async () => {
    // const arrayToSave = [1, 2, 3, 4, 5];
    // Convert the array to a JSON string
    const jsonData = JSON.stringify(list);
    // Create a Blob object with the JSON data
    if (jsonData.length > 500) {
      const blob = new Blob([jsonData], { type: "application/json" });
      saveAs(blob, "data.json");

      // Add a new document in collection "cities"
      await setDoc(doc(firestoredb, "map", mapNumber), list)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // Save the Blob object as a file
  };

  const buyLand = async () => {
    console.log(modalData);
    navigate("/buyland", { state: modalData })
    setShowModal(true);
  };

  // const getAllNftss = async () => {
  //   await getAllNfts().then(async (res) => {
  //     console.log(res);
  //   }).catch(err => {
  //     console.log(err);
  //   })
  // };

  // useEffect(() => {
  //   getAllNftss();
  // }, []);

  const getMapData1 = async () => {
    const mapdata = await getmapdata();
    console.log("Bro Map data")
    console.log(mapdata);
    setAllSquares(mapdata);
  };

  useEffect(() => {
    getMapData1();
  }, []);
  useEffect(() => {
    setListArrayEven1();
    setListArrayEven2();
    setListArrayEven3();
    setListArrayEven4();
    setListArrayEven5();
    setListArray4();
    setListArray();
    setListArray1by1();
  }, []);
  useEffect(() => {
    // if (nowDownload) {
    //   saveArrayToFile()
    // } else {
    //   // console.log("not downloading");
    // }
  }, [list, nowDownload]);

  const checkIsApproved = async () => {
    if (address) {
      const isApproved = await getTokenApproval(address);
      console.log("in component is Approved: ", isApproved);
      setUserTokenApproved(isApproved);
    }
  }
  const handleTokensApproval = async () => {
    await approveFtTokens(signer)
      .then(async (res) => {
        console.log(res);
        if (res.success) {
          console.log("Token Approved Successfully");
        }
        setUserTokenApproved(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    checkIsApproved();
  }, [address]);


  const handleClose = () => {
    setShow(false);
    setShowModal(false);
    setModalData({});
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setName("");
    setImage("");
    setDescription("");
  };

  const handleShow = (id) => {
    setShow(true);
  };

  const panningHandler = () => {
    document.getElementById("myWrapperall").style.pointerEvents = "none";

    // setpanningFlag(true);
  };
  const panningStopHandler = () => {
    document.getElementById("myWrapperall").style.pointerEvents = "auto";

    // setpanningFlag(false);
  };

  const onTileClick = (id, data) => {

    console.log(id, data);
    const splat = id.split("-");
    var tileImage = [];
    if (data.bought) {
      tileImage = data.background.split("(")
    }
    setModalData({ id, data: data, mapNumber: splat[0], tileImage: tileImage[1] });
    setShow(true);
    data.discountedPrice = data.price - data.price * 0.8;
    data.totalFee = data.discountedPrice * 0.1;
    data.totalTax = data.discountedPrice * 0.05;
    data.finalPrice = data.discountedPrice + data.totalFee + data.totalTax;
  };


  const validationForBuy = () => {
    var obj = { nameError: false, descriptionerror: false, imageError: false, brandurl: false, acceptAgreement: false };
    if (name == "") {
      obj.nameError = true;
      toast("Please enter name");
    }
    if (description == "") {
      obj.descriptionerror = true;
      toast("Please enter description");
    }
    if (image == "") {
      obj.imageError = true;
      toast("Please upload image");
    }
    if (brandUrl == "") {
      obj.brandurl = true;
      toast("Please enter brand url");
    }
    if (acceptAgreement == false) {
      obj.acceptAgreement = true;
      toast("Please Accept Astrality purchase Agreement");
    }
    return obj;
  };

  const handleBuyNow = async () => {
    var validation = validationForBuy();
    console.log(validation);
    if (
      validation.descriptionerror ||
      validation.imageError ||
      validation.nameError ||
      validation.brandurl || validation.acceptAgreement
    ) {
      console.log("error");
    } else {
      console.log("ok");
      // console.log(modalData);
      console.log(modalData.data.finalPrice);
      console.log(modalData.id);

      await buyLandC(
        modalData.data.finalPrice,
        modalData.data.randomNumber,
        modalData.id,
        signer,
        address
      )
        .then(async (res) => {
          console.log(res.success);
          if (res.success) {
            if (userisLogged) {
              await uploadImgPlot(image, userisLogged)
                .then(async (res) => {
                  console.log(res);
                  // setDownloadUrl(res)
                  await setDoc(
                    doc(firestoredb, "map", modalData.mapNumber),
                    {
                      [modalData.id]: {
                        background: `url(${res})`,
                        bought: true,
                        name: name,
                        description: description,
                        brandUrl: brandUrl
                      },
                    },
                    { merge: true }
                  );
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              toast("Please login");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleBuyRent = async () => {
    console.log("Address", address);
    console.log("Token ID", modalData.data.randomNumber);
    console.log("Rent Price", modalData.data.rentPrice);

    await buyRentOffer(
      address,
      modalData.data.randomNumber,
      modalData.data.rentPrice,
      signer,
    )
      .then(async (res) => {
        console.log(res.success);
        if (res.success) {
          if (userisLogged) {
            await setDoc(
              doc(firestoredb, "map", modalData.mapNumber),
              {
                [modalData.id]: {
                  boughtRented: true,
                  listRented: false,
                  rentBuyAddress: address
                },
              },
              { merge: true }
            )
              .then(async (res) => {
                console.log(res);
                // setDownloadUrl(res)

              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            toast("Please login");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }

  const [userisLogged, setUserisLogged] = useState();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
      } else {
        setUserisLogged(user);
      }
    });
    return () => unsubscribe();
  }, []);



  return (
    <>
      <div className="myWrapper" id="myWrapperall" >
        <TransformWrapper
          initialScale={0.7}
          minScale={0.4}
          maxScale={5}
          limitToBounds={false}
          onPanning={panningHandler}
          onPanningStop={panningStopHandler}
          centerOnInit={true}
        >
          <TransformComponent ref={draggableDivRef}>
            {AllSquares.map((item, index) => {
              return (
                <div
                  className="fixed-wrapper"
                  ref={contentRef}
                >
                  <FixedSizeGrid
                    columnCount={item.numCols}
                    rowCount={item.numRows}
                    columnWidth={tileWidth}
                    rowHeight={tileHeight}
                    width={440}
                    height={380}
                    className="FixedSizeGrid"
                  >
                    {({ columnIndex, rowIndex, style }) => {
                      const tileId = `${item.id}-${rowIndex}-${columnIndex}`;
                      const tile = item.mapdata[tileId];
                      const tileSize = tile?.size || "1-1";
                      const [tileWidth, tileHeight] = tileSize.split("-");

                      return (
                        <div
                          key={tileId}
                          style={{
                            ...style,
                            width: tileWidth * 20, // Convert to pixels
                            height: tileHeight * 20, // Convert to pixels
                          }}
                          className="tile"
                        >
                          {tile ? (
                            <div
                              id={tileId}
                              style={{
                                position: "relative",
                                zIndex: 999,
                                width: tileWidth * 20, // Convert to pixels
                                height: tileHeight * 20, // Convert to pixels
                                marginTop: "-1px",
                                marginLeft: "-1px",
                                background: tile.background,
                                border: "1px solid #fff",
                                backgroundSize: "100%",
                              }}

                              onClick={(e) => { onTileClick(tileId, tile); }}
                            ></div>
                          ) : (
                            <></>
                          )}
                        </div>
                      );
                    }}
                  </FixedSizeGrid>
                </div>
              );
            })}
          </TransformComponent>
        </TransformWrapper >
      </div >
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="mapOffCanvas"
      >
        <Offcanvas.Header closeButton>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="canvas-content">
            <div className="map-img">
              {modalData?.tileImage ? <img src={modalData?.tileImage} alt="" /> : <img src="\assets\images\CanvasImage.png" alt="" />}
            </div>
            <h1 className="canvas-heading">{modalData?.data?.name ? modalData?.data?.name : "Pionner Land"}</h1>
            <p className="canvas-para">
              {
                modalData?.data?.description ? modalData?.data?.description :
                  " This LAND is part of the MYDoge LAND Sale. You can get this LAND joining the the brand MYDOGE."
              }
            </p>
            <div className="coordinate-size">
              <div className="coordinate">
                <p className="coordinate-size">Cordinates</p>
                <p className="numbers">
                  <img src="\assets\images\MapCanvasIcon.svg" alt="" />
                  {modalData?.id}
                </p>
              </div>
              <div className="coordinate">
                <p className="coordinate-size">Size</p>
                <p className="numbers">{modalData?.data?.size}</p>
              </div>
            </div>

            {
              modalData?.data?.brandUrl ? <div className="link mb-4">
                <p className="mb-1">Brand Url</p>
                <a href={modalData?.data?.brandUrl} target="_blank">{modalData?.data?.brandUrl}</a>
              </div> : <div className="link">
                <p className="mb-1">Owner</p>
                <a href="#">@Astrality</a>
              </div>
            }


            <div className="link mt-4 status">
              <p>Status</p>
              {modalData?.data?.bought ? <a>{modalData?.data?.listRented ? "Land is listed for Rent" : modalData?.data?.boughtRented ? "Land is Rented Out" : "Land is bought but not listed for rent!"} </a> : <a>Available for buy</a>}

              {modalData?.data?.listRented ?
                <>
                  <p>Price</p>
                  <div> {modalData?.data?.rentPrice} USDT</div>
                </>
                : null}
            </div>
            <div className="coordinate-size">
              <div className="coordinate">
                <p className="coordinate-size">Blockchain</p>
                <p className="numbers">Ethereum</p>
              </div>
              <div className="coordinate">
                <p className="coordinate-size">Token ID</p>
                <p className="numbers">{modalData?.data?.randomNumber}</p>
              </div>


            </div>
            <div className="buy-btn">
              {address ? userTokenApproved ? modalData?.data?.bought ? modalData?.data?.listRented ? <button onClick={handleBuyRent} >Buy Rent</button> : <button disabled >Sold</button> : userisLogged ? <button onClick={buyLand}>Buy</button> : <button onClick={(e) => navigate("/login")}>Sign in</button> : <button onClick={handleTokensApproval}>Approve Tokens</button> :

                <ConnectButton.Custom>
                  {({
                    account,
                    chain,
                    openAccountModal,
                    openChainModal,
                    openConnectModal,
                    authenticationStatus,
                    mounted,
                  }) => {
                    // Note: If your app doesn't use authentication, you
                    // can remove all 'authenticationStatus' checks
                    const ready = mounted && authenticationStatus !== 'loading';
                    const connected =
                      ready &&
                      account &&
                      chain &&
                      (!authenticationStatus ||
                        authenticationStatus === 'authenticated');

                    return (
                      <div
                        {...(!ready && {
                          'aria-hidden': true,
                          'style': {
                            opacity: 0,
                            pointerEvents: 'none',
                            userSelect: 'none',
                          },
                        })}
                      >
                        {(() => {
                          if (!connected) {
                            return (
                              <button onClick={openConnectModal} type="button">
                                Connect Wallet
                              </button>
                            );
                          }

                        })()}
                      </div>
                    );
                  }}
                </ConnectButton.Custom>
              }

            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>



      <Modal
        show={showModal}
        onHide={handleCloseModal}
        animation={false}
        centered
        className=" purchase-modal"
        size="xl"
      >
        <Modal.Header className="modal-header" closeButton>
          <Modal.Title className="modal-title">
            <h2 className="body-medium ">Purchase Terms and Conitions</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <div className="first">
            <div className="left">
              <div className="pioneer-land-img">
                <label htmlFor="imagePicker">
                  <input
                    id="imagePicker"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                    className="d-none"
                  />
                  {
                    image == "" ? <img
                      src="\assets\images\CanvasImage.png"
                      alt=""
                      className="img-fluid cursor-pointer"
                    /> : <img
                      src={URL.createObjectURL(image)}
                      alt=""
                      className="img-fluid cursor-pointer"
                    />
                  }

                  <div className="heading-for-pick">
                    <h2>Upload Image</h2>
                  </div>

                </label>

              </div>
              <div className="left-content">
                <h3>Pioneer Land</h3>
                <div className="icon-para d-flex align-content-center ">
                  <img src="\assets\images\MapCanvasIcon.svg" alt="" />
                  <p className="para text-light-green">{modalData?.id}</p>
                </div>
              </div>
            </div>
            <div className="right">
              <p>USDT {modalData?.data?.price}</p>
            </div>
          </div>

          <div className="second">
            <div className="mid-one">
              <div>
                <input type="text" placeholder="Enter Name" onChange={(e) => setName(e.target.value)} />
              </div>
              <div>
                <input type="url" placeholder="Enter Brand Url" onChange={(e) => setBrandUrl(e.target.value)} />
              </div>
              <div>
                <textarea
                  onChange={(e) => setDescription(e.target.value)}
                  name=""
                  id=""
                  cols="30"
                  rows="3"
                  placeholder="Enter Description here"
                ></textarea>
              </div>

            </div>
            <div className="main">
              <div className="div-1">
                <p>Discounted Price:</p>
                <h5>USDT {modalData?.data?.discountedPrice}</h5>
              </div>
              <div className="div-1">
                <p>10% platform fee:</p>
                <h5>USDT {modalData?.data?.totalFee}</h5>
              </div>
              <div className="div-1">
                <p>5% tax:</p>
                <h5>USDT {modalData?.data?.totalTax}</h5>
              </div>
            </div>
          </div>
        </Modal.Body>

        <div className="modal-footer">
          <div className="content">
            <p>Final Price:</p>
            <h5>USDT {modalData?.data?.finalPrice}</h5>
          </div>
          <div className="for-border">
            <div className="agree ">
              <div className="d-flex align-items-center mt-0">
                <label htmlFor="acceptAgreement">
                  <input type="checkbox" name="" id="acceptAgreement" onChange={(e) => { setAcceptAgreement(e.target.checked) }} />
                  I agree to the terms of
                  the Astrality purchase Agreement
                </label>
              </div>
              <div className="list">
                <h5>After purchase, this asset:</h5>
                <ul>
                  <li>will not be tradable at initial stage</li>
                  <li>can rent out to advertiser</li>
                </ul>
              </div>
            </div>
            <div className="footer-btn">
              <button className="back" onClick={handleCloseModal}>Back to Map</button>
              <button className="confirm" onClick={handleBuyNow}>Confirm Purchase</button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TileGrid;
